module.exports = __webpack_public_path__ + "static/d7b0290e73c93691ea1675ac0a1e39ce.png";